import axiosInstance from '@/app/api/axiosInstance';
import { AccountTypeResponse } from '@/app/types';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';

export const listAccountTypes = async (params: ListQueryParams): Promise<PaginatedResponse<AccountTypeResponse>> => {
  try {
    const response = await axiosInstance.get<PaginatedResponse<AccountTypeResponse>>('/account-types/', { 
      params 
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to list account types:', error);
    throw error;
  }
};

export const getAccountType = async (accountTypeId: number): Promise<AccountTypeResponse> => {
  try {
    const response = await axiosInstance.get<AccountTypeResponse>(`/account-types/${accountTypeId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get account type with ID ${accountTypeId}:`, error);
    throw error;
  }
};

// Account types are predefined and managed by superusers, so we don't need
// create, update, or delete functions in the frontend 